import { useCallback } from 'react';
import { useImage } from 'shared/hooks/useImage';
import { MAP_BRAND_COLOR_RAW_HEX } from 'shared/utils/mapIconGenerators';
import use1rem from 'shared/utils/use1rem';

// const carPhotoUrl = '/top-car.png';
// const carPhotoUrl = '/top-car3.png';

// Extracted from Lyft's concierge map
const carPhotoUrl = `data:image/png;base64,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`;

function getRotatedPhoto({
	image,
	degrees = 0,
	sourceUrl,
	width: inputWidth,
	height: inputHeight,
	shadow,
	filter,
}) {
	const angle = (degrees * Math.PI) / 180;

	// eslint-disable-next-line no-undef
	const renderImage = image || new Image();
	if (!image && sourceUrl) {
		renderImage.src = sourceUrl;
	}

	const height = inputHeight || renderImage.height;
	const width = inputWidth || renderImage.width;

	const canvas = document.createElement('canvas');
	canvas.width = width * 2;
	canvas.height = height * 2;
	const context = canvas.getContext('2d');

	const centerX = width; // / 2;
	const centerY = height; // / 2;

	context.clearRect(0, 0, width, height);
	context.save();
	context.translate(centerX, centerY);
	context.rotate(angle);
	context.translate(-centerX, -centerY);

	if (shadow) {
		Object.entries(shadow).forEach(([key, value]) => {
			context[key] = value;
		});
	}

	// context.filter = 'grayscale(100%) invert(100%)';
	if (filter) {
		context.filter = filter;
	}

	context.drawImage(renderImage, width / 2, height / 2);
	context.restore();

	return canvas.toDataURL('image/png');
}

// AR of original image
// const aspectRatio = 565 / 800;
// const aspectRatio = 250 / 256;
const aspectRatio = 28 / 42;

export function useCarIconGenerator() {
	// Need our custom hook to load the image because if we just declare it statically
	// at top-of-file and set the .src prop there, the useMemo() below that renders
	// the image never gets changed when the image loads because loading is async.
	// This hook will take care of that for us and fire a state-change when the
	// image .onload event fires so that we're sure to change any memos that rely
	// on this image for rendering. Niche case admittedly, but crucial for proper
	// dynamic image rotation via useMemo hooks.
	const carImage = useImage(carPhotoUrl);

	const rem1 = use1rem();

	// ~2 = rem size, *2 is to compensate for size of canvas for rotation
	const iconSize = rem1 * 2.125 * 2;

	return useCallback(
		(heading = 0) => ({
			url: getRotatedPhoto({
				image: carImage,
				degrees: heading,
				shadow: {
					shadowColor: `#${MAP_BRAND_COLOR_RAW_HEX}`,
					shadowBlur: rem1 * 8,
				},
				filter: `drop-shadow(0 0 8px #${MAP_BRAND_COLOR_RAW_HEX})`,
			}),
			scaledSize: {
				width: iconSize * aspectRatio,
				height: iconSize,
			},
			anchor: { x: (iconSize / 2) * aspectRatio, y: iconSize / 2 },
			labelOrigin:
				window.google &&
				new window.google.maps.Point(
					(iconSize / 2) * aspectRatio,
					iconSize * 0.75,
				),
		}),
		[carImage, rem1, iconSize],
	);
}

export function useCarIcon(heading) {
	return useCarIconGenerator()(heading);
}
